import { Link, post, useState, MyIcon, config, useNavigate, useEffect, MsgCaptcha } from '@/common';
import { Form, Input, Button } from 'antd';
import {
    MobileOutlined,
    KeyOutlined,
    SafetyOutlined
} from '@ant-design/icons';
import '@/assets/style/entrance.scss';
import Copyright from '@/components/Copyright';

function Main(props: any) {
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [type, setLoginType] = useState('password');

    const onFinish = (data: any) => {
        setLoading(true)
        data['type'] = type
        post('/authority/login', data).then(data => {
            if (data.code) return
            data = data.data
            localStorage.setItem('member', JSON.stringify(data.member))
            localStorage.setItem('module', JSON.stringify(data.module))
            localStorage.setItem('config', JSON.stringify(data.config))
            // window.location.href = '/'
            window.location.href = '/statistic/overview'
        }).finally(() => {
            setLoading(false)
        })
    }
    useEffect(() => {
        // 已登录跳转
        if (localStorage.getItem('member')) {
            navigate('/statistic/overview')
        }
    }, [])
    return (
        <div className="entrance">
            <Form
                className="form"
                onFinish={onFinish}
                form={form}
            >
                <img className="logo" src="/images/logo.jpg" alt="LOGO" />
                <div className="name">{config.app.name}</div>
                <Form.Item
                    name="phone"
                    rules={[{ required: true, message: '手机号为必填' }]}
                >
                    <Input size="large" placeholder="请输入手机号" prefix={<MobileOutlined />} />
                </Form.Item>
                {
                    type === 'password' ?
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '密码为必填' }]}
                        >
                            <Input.Password size="large" placeholder="请输入密码" prefix={<KeyOutlined />} />
                        </Form.Item>
                        :
                        <Form.Item
                            className="captcha"
                        >
                            <Form.Item
                                noStyle
                                name="captcha"
                                rules={[{ required: true, message: '验证码为必填' }]}
                            >
                                <Input size="large" placeholder="请输入验证码" maxLength={4} prefix={<SafetyOutlined />} />
                            </Form.Item>
                            <MsgCaptcha form={form} type="login" />
                        </Form.Item>

                }
                <Button size="large" type="primary" htmlType="submit" block loading={loading}>
                    登陆
                </Button>
                <div className="register">
                    {/* <Link to="/register">立即注册</Link> */}
                    <div></div>
                    <Link to="/find_pw">忘记密码？</Link>
                </div>
                <div className="line">
                    <div></div>
                    <span>其它登录方式</span>
                    <div></div>
                </div>
                <div className="other">
                    {
                        type === 'password' ?
                            <MyIcon className="phone" type="icon-shoujihao" title="手机号登录" onClick={() => { setLoginType('phone') }} /> :
                            <MyIcon className="phone" type="icon-mima" title="密码登录" onClick={() => { setLoginType('password') }} />

                    }
                    <MyIcon className="wx" type="icon-weixin" title="微信号登录" />
                </div>
            </Form>
            <Copyright />
        </div>
    )
}

export default Main